import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Service History</h3>
                <p className="text-sm text-gray-600">
                    Track all maintenance and service logs for your vehicle fleet.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Logging Maintenance</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Service</strong> to record a performed maintenance task.</li>
                    <li>Select the <strong>Vehicle</strong>, <strong>Vendor</strong>, and <strong>Service Types</strong> (e.g., Oil Change, Brake Repair).</li>
                    <li>Record any additional <strong>Notes</strong> for future reference or diagnostic history.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Monitoring Status</h4>
                <p className="text-sm text-gray-600">
                    Keep track of whether a service record is Open, Completed, or Pending. This helps in managing ongoing shop visits.
                </p>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Reporting</h4>
                <p className="text-sm text-gray-600">
                    Filter by date or search for specific vehicles to generate maintenance history reports. Export these as <strong>PDF</strong> or <strong>CSV</strong> for internal records or vehicle resale value documentation.
                </p>
            </section>
        </div>
    );
};

export default Help;
